import React, {useEffect} from 'react'
import {Link} from "react-router-dom";
import Header from '../../header/Header';
import Sidebarr from '../../sidebar/Sidebar';
import Tool from '../../sidebar/Tool';
import Footer from '../../footer/Footer';
import {CustomerAction,updateVendorStatus,vendorDelete} from "../../action";
import {useDispatch,useSelector} from "react-redux";

export default function ProductList() {
  const customer = useSelector(state=>state?.vendor?.customer);

  const dispatch = useDispatch();
  const vendorGetData=()=>{
    dispatch(CustomerAction());
  }
  useEffect(()=>{
    vendorGetData();  
  },[])

  const blockStatus=(id)=>{
    const status="block";
    const data={id,status}
    dispatch(updateVendorStatus(data));
   vendorGetData(); 

    
  }
  const unBlockStatus=(id)=>{
    const status="active";
    const data={id,status}
    dispatch(updateVendorStatus(data));
    vendorGetData(); 
  }

  const deleteVendorBtn=(id)=>{ 
    const data={id}
    dispatch(vendorDelete(data));
  }
 
  const check=()=>{
    vendorGetData()
  }

	return (
		<div className="sidebar-mini skin-green-light">
		<div className="wrapper"> 
  		  <Header/> 
  		  <Sidebarr/>
         
  {/* Content Wrapper. Contains page content */}
  <div className="content-wrapper">
    {/* Content Header (Page header) */}
    <section className="content-header">
      <h1>
        Manage All Customers 
      </h1>
      <ol className="breadcrumb">
        <li>
          <a href="#">
            <i className="fa fa-dashboard" /> Home
          </a>
        </li>
        <li>
          <a href="#">Product Manage</a>
        </li>
        <li className="active">All Product</li>
      </ol>
    </section>
    {/* Main content */}
    <section className="content">
      {/* Default box */}
      <div className="box">
         
        <div className="box-body">
        	<table className="table table-bordered table-striped dataTable" id="example1">
        	  <thead>
        	    <tr>
        	  	<th className="fw-bold">{" "}<input type="checkbox"/></th>
        	  	<th>Customer Name</th>
        	  	<th>Customer Email</th>
        	  	<th>Customer Phone</th>
        	  	<th>Status</th>
        	  	<th>Action</th>
        	  	</tr>
        	  </thead>
        	  <tbody>
            {customer?.length>0?customer?.map(vd=>(
        	  	<tr>
        	  		<td><input type="checkbox"/></td>
        	  		<td>
        	  			<span className="text-uppercase fs-1">{vd.fname}</span>
        	  		</td>
        	  		<td>
        	  			
                  <span className="text-uppercase fs-1">{vd.email}</span>
        	  		</td>
        	  		<td>
                  <span className="text-uppercase fs-1">{vd.phoneNumber}</span></td>
        	  		<td>
                  <span className="text-uppercase fs-1">{vd.status}</span></td>
        	  		<td>
        	  			{/*<button className="btn btn-default" onClick={(e)=>deleteVendorBtn(vd._id)}>
        	  				<i className="fa fa-trash"></i>
        	  			</button>*/}
        	  			{" "}
                  {" "}
                  {vd.status==="block"?
                  <button className="btn btn-default" onClick={(e)=>unBlockStatus(vd._id)}>
                    Unblock
                  </button>:
                  <button className="btn btn-default" onClick={(e)=>blockStatus(vd._id)}>
                    Block
                  </button>}

                  {" "}
                  {" "}

                  <Link to={`/details/${vd.email}`} className="btn btn-default">
                    <i className="fa fa-info"></i>
                  </Link>
        	  		</td>
        	  	</tr>
              )):"No Data Found"
            }
        	  </tbody>
        	</table>
        </div> 
      </div> 
    </section> 
  </div> 
  <Footer/>
  <Tool/>  
  <div className="control-sidebar-bg" />
</div>

			
		</div>
	)
}